import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { SignedIn, SignedOut, SignIn, SignUp, RedirectToSignIn } from '@clerk/clerk-react'
import { Layout } from './components/layout/Layout'
import { Dashboard } from './components/game/Dashboard'
import { Inventory } from './components/game/Inventory'
import { Market } from './components/game/Market'
import { Production } from './components/game/Production'
import { BrandManagement } from './components/game/BrandManagement'
import { CopyrightManagement } from './components/game/CopyrightManagement'
import { EmployeeManagement } from './components/game/EmployeeManagement'
import { MachineryShop } from './components/game/MachineryShop'
import { ProductRequestManager } from './components/game/ProductRequestManager'
import { CryptoWalletManager } from './components/game/CryptoWalletManager'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/sign-in/*" element={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <SignIn 
                appearance={{
                  elements: {
                    formButtonPrimary: 'bg-blue-600 hover:bg-blue-700 text-sm normal-case',
                    card: 'bg-white shadow-lg',
                    headerTitle: 'text-2xl font-bold text-gray-900',
                    headerSubtitle: 'text-gray-600',
                    socialButtonsBlockButton: 'bg-white border border-gray-300 hover:bg-gray-50',
                    formFieldInput: 'border border-gray-300 focus:border-blue-500 focus:ring-blue-500',
                    footerActionLink: 'text-blue-600 hover:text-blue-700'
                  }
                }}
                routing="path"
                path="/sign-in"
                signUpUrl="/sign-up"
              />
            </div>
          } />
          <Route path="/sign-up/*" element={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <SignUp 
                appearance={{
                  elements: {
                    formButtonPrimary: 'bg-blue-600 hover:bg-blue-700 text-sm normal-case',
                    card: 'bg-white shadow-lg',
                    headerTitle: 'text-2xl font-bold text-gray-900',
                    headerSubtitle: 'text-gray-600',
                    socialButtonsBlockButton: 'bg-white border border-gray-300 hover:bg-gray-50',
                    formFieldInput: 'border border-gray-300 focus:border-blue-500 focus:ring-blue-500',
                    footerActionLink: 'text-blue-600 hover:text-blue-700'
                  }
                }}
                routing="path"
                path="/sign-up"
                signInUrl="/sign-in"
              />
            </div>
          } />
          <Route path="/" element={
            <>
              <SignedIn>
                <Layout />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }>
            <Route index element={<Dashboard />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="market" element={<Market />} />
            <Route path="production" element={<Production />} />
            <Route path="brands" element={<BrandManagement />} />
            <Route path="copyright" element={<CopyrightManagement />} />
            <Route path="employees" element={<EmployeeManagement />} />
            <Route path="machinery" element={<MachineryShop />} />
            <Route path="product-requests" element={<ProductRequestManager />} />
            <Route path="crypto-wallet" element={<CryptoWalletManager />} />
          </Route>
        </Routes>
      </div>
    </Router>
  )
}

export default App
